var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNike = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M6.399 19.609q-2.432-.097-3.987-1.333a8 8 0 0 1-.829-.829 5.2 5.2 0 0 1-.898-1.615c-.587-1.76-.285-4.067.865-6.6.984-2.17 2.503-4.32 5.152-7.299.39-.438 1.553-1.72 1.56-1.72.003 0-.06.11-.14.243-.689 1.154-1.278 2.513-1.6 3.69-.515 1.888-.453 3.508.183 4.765.438.865 1.19 1.615 2.036 2.03 1.48.725 3.647.785 6.294.175.182-.042 9.212-2.44 20.065-5.327S54.837.541 54.838.543c.003.002-25.217 10.794-38.309 16.392-2.073.887-2.628 1.11-3.602 1.453-2.492.875-4.724 1.292-6.528 1.22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNike);
export default ForwardRef;